import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    if (import.meta.env.DEV) {
      console.warn('Sentry DSN not configured. Set VITE_SENTRY_DSN in .env to enable error tracking.');
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Scrub PII from error events
      if (event.user) {
        delete event.user.ip_address;
      }
      return event;
    },
  });
}

export function captureError(error: Error, context?: Record<string, unknown>) {
  if (context) {
    Sentry.setContext('additional', context);
  }
  Sentry.captureException(error);
}

export function setUser(user: { id: string; email: string; role: string } | null) {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email });
    Sentry.setTag('user_role', user.role);
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };
